/**
 * @auth 赖传峰
 * @date 2023/2/24
 */
import {
  computed,
  useRoute,
} from '#imports'
import type { ComputedRef } from 'vue'
import {
  RoutePath,
  SupportLocale,
} from '~/types/enum'
import removeLocaleFromPath from '~/utils/removeLocaleFromPath'

export default (): ComputedRef<RoutePath> => computed(() => removeLocaleFromPath(useRoute().path as RoutePath | `/${SupportLocale}${RoutePath}`))
